import styled from 'styled-components';

const CommonDiv = styled.div`
  line-height: 1.5;
  margin-bottom: 28px;
  align-items: center;
`;

export default CommonDiv;
